function CheckboxIcon({ checked = false }) {
    if (checked) {
        return (
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <rect width="18" height="18" rx="2" fill="#9066F6" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.2244 4.97572C14.4587 5.21004 14.4587 5.58994 14.2244 5.82425L7.62436 12.4243C7.39005 12.6586 7.01015 12.6586 6.77583 12.4243L3.77583 9.42425C3.54152 9.18994 3.54152 8.81004 3.77583 8.57572C4.01015 8.34141 4.39005 8.34141 4.62436 8.57572L7.2001 11.1515L13.3758 4.97572C13.6101 4.74141 13.99 4.74141 14.2244 4.97572Z"
                    fill="white"
                />
            </svg>
        );
    }

    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <rect width="18" height="18" fill="white" />
            <rect
                x="0.5"
                y="0.5"
                width="17"
                height="17"
                rx="1.5"
                fill="white"
                stroke="#D5D5D5"
            />
        </svg>
    );
}

export default CheckboxIcon;
